import styled from 'styled-components';
import { Modal } from 'lib/components/Modal/Modal';

export const StyledCustomerInviteUserModal = styled(Modal)`
  .invite-user__buttons {
    display: flex;
    justify-content: space-between;
  }
`;
